import { addAllSuggestionsTelemetry } from '../actions/smartComposePluginActions';
import SessionTelemetry from '../store/schema/SessionTelemetry';
import Suggestion from '../store/schema/Suggestion';
import { logRequestSuggestion } from '../telemetryHelpers/logDatapoints';
import updateTelemetryForSuggestionOnSuggestionReturned from '../telemetryHelpers/updateTelemetryForSuggestionOnSuggestionReturned';
import updateTelemetryForSessionWithSessionDetails from '../telemetryHelpers/updateTelemetryForSessionWithSessionDetails';
import initializeSuggestion from '../utils/initializeSuggestion';
import { trace } from 'owa-trace';
import { ISuggestion } from '@qas/smartcompose-tslibrary/dist/src/session';
import { SmartComposeInteraction } from '@qas/smartcompose-tslibrary/dist/src/smartComposeInteraction';

export default function handleSuggestionResponse(
    suggestionResponse: ISuggestion | any,
    sessionTelemetry: SessionTelemetry,
    currentSmartComposeSession: any,
    currentSuggestionTelemetry: SmartComposeInteraction
): Suggestion {
    addAllSuggestionsTelemetry(currentSuggestionTelemetry);

    if (suggestionResponse) {
        let traceId: string;
        let serviceLatency: number;
        let suggestion: string;
        let suggestionSource: string;
        let modelVersion: string;
        let sessionId: string;

        if (suggestionResponse.suggestion || suggestionResponse.modelVersion) {
            // legacy shape has the 'suggestion' and 'modelVersion' property
            traceId = suggestionResponse.traceId;
            serviceLatency = suggestionResponse.serviceLatency;
            suggestion = suggestionResponse.suggestion;
            suggestionSource = suggestionResponse?.suggestionSource?.toString();
            modelVersion = suggestionResponse.modelVersion;
        } else {
            // new shape does not have the 'suggestion' property. It is named 's' instead
            traceId = suggestionResponse.t;
            serviceLatency = suggestionResponse.l;
            suggestion = suggestionResponse.s;
            suggestionSource = suggestionResponse?.x?.toString();
            modelVersion = suggestionResponse.m;
            sessionId = suggestionResponse.i;
        }

        updateTelemetryForSuggestionOnSuggestionReturned(
            currentSuggestionTelemetry,
            traceId,
            serviceLatency,
            !!suggestion,
            suggestion,
            suggestionResponse && suggestionSource,
            sessionId
        );

        updateTelemetryForSessionWithSessionDetails(sessionTelemetry, modelVersion, sessionId);
        logRequestSuggestion(currentSuggestionTelemetry, currentSmartComposeSession);

        return initializeSuggestion(
            suggestion,
            null /* suggestionNode is null because the suggestion has not yet been inserted into the editor */,
            currentSuggestionTelemetry
        );
    } else {
        trace.info('[SmartComposePlugin] no suggestion response');
        return null;
    }
}
